import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';

import { WellFargoFileIngestionTable } from './table';

export function WellsFargoFileIngestions() {
	return (
		<>
			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">Wells Fargo Feed</CardTitle>
					</span>
				</CardHeader>
				<CardContent className="space-y-2">
					<WellFargoFileIngestionTable />
				</CardContent>
			</Card>
		</>
	);
}
